// src/Components/WelcomeBack.tsx
import React, { useEffect, useState } from 'react';
import { BirdLogo } from 'assets/icons';

interface WelcomeBackProps {
  onContinue: () => void;
}

const WelcomeBack: React.FC<WelcomeBackProps> = ({ onContinue }) => {
  const [animateClass, setAnimateClass] = useState('scale-90 opacity-0');

  useEffect(() => {
    const entranceTimer = setTimeout(() => {
      setAnimateClass('scale-100 opacity-100');
    }, 10);

    const exitTimer = setTimeout(() => {
      setAnimateClass('scale-90 opacity-0');
    }, 1000);

    const finishTimer = setTimeout(() => {
      onContinue();
    }, 1500);

    return () => {
      clearTimeout(entranceTimer);
      clearTimeout(exitTimer);
      clearTimeout(finishTimer);
    };
  }, [onContinue]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-transparent backdrop-blur-sm">
      <div
        className={`bg-white bg-opacity-90 rounded shadow-xl p-12 max-w-xl w-full transform transition-all duration-500 ease-in-out ${animateClass}`}
      >
        <BirdLogo className="mx-auto mb-4 w-24 h-24" />
        <h2 className="text-4xl font-bold mb-4 text-green-500 text-center">
          Welcome Back to AOA!
        </h2>
        <p className="text-2xl mb-4 text-green-500 text-center">
          We&apos;re happy to see you. Redirecting shortly...
        </p>
      </div>
    </div>
  );
};

export default WelcomeBack;
